import { getImageUrl } from "../admin/api/masterApi";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL || "https://api.trivomtara.com/api"
).replace(/\/$/, "");

export const ASSET_TYPES = {
  PRODUCTS: 1,
  SERVICES: 2,
  CLASSES: 3,
};

function parseGallery(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (_error) {
    return [];
  }
}

export function mapAsset(asset) {
  const images = [
    asset.asset_profile_picture,
    ...parseGallery(asset.asset_picture_gallery),
    asset.service_icon,
  ].filter(Boolean);

  return {
    ...asset,
    id: asset.service_id,
    title: asset.service_title,
    category: asset.service_category_name || "General",
    subCategory: asset.service_sub_category_name || "",
    image: getImageUrl(images[0]),
    description: asset.short_description || asset.long_description || "",
    price: asset.price_inr == null ? null : Number(asset.price_inr),
  };
}

export async function fetchAssetsByType(assetTypeId) {
  const response = await fetch(`${API_BASE_URL}/services`);
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch assets");
  }

  return (data.data || [])
    .filter(
      (asset) =>
        Number(asset.asset_type_id) === Number(assetTypeId) &&
        (asset.status === undefined || Number(asset.status) === 1)
    )
    .map(mapAsset);
}

export async function fetchAssetById(id, assetTypeId) {
  const response = await fetch(`${API_BASE_URL}/services/${id}`);
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Asset not found");
  }
  if (Number(data.data?.asset_type_id) !== Number(assetTypeId)) {
    throw new Error("Asset not found");
  }
  return mapAsset(data.data);
}

export function formatAssetPrice(value) {
  if (value == null || value === "") return "";
  return Number(value).toLocaleString("en-IN");
}
